import Axios from "axios";
import { headers, SALES_SCHEDULING } from "../../config";

export function getSchedulingStates() {
    return Axios.get(`${SALES_SCHEDULING}/schedules-states`, { headers: headers() })
}

export function getIdempotentKey() {
    return Axios.get(`${SALES_SCHEDULING}/dpk`, { headers: headers() })
}